<template>
  <div>
    <Layout
      username="Supervisor"
      current-page="Agents"
      link-to-edit="/sup-dashboard/edit-profile"
    >
      <template slot="menuItems">
        <li v-for="{ title, icon, path } in menu" :key="title" class="nav-item">
          <MenuItems :menu-item="title" :icon-menu="icon" :to-where="path" />
        </li>
      </template>
      <template slot="content">
        <div class="row">
          <div
            v-for="(agent, key) in agents"
            :key="key"
            class="col-12 col-lg-3 mb-4"
          >
            <a-card hoverable>
              <img slot="cover" alt="example" :src="defaultImage" />
              <template slot="actions" class="ant-card-actions">
                <span class="text-uppercase">{{ agent.role }}</span>
              </template>
              <a-card-meta :title="agent.name || agent.username">
                <template slot="description">
                  <div>
                    <p class="my-1">
                      Phone Number: {{ agent.phoneNumber || "---" }}
                    </p>
                    <p class="my-1">Address: {{ agent.address || "---" }}</p>
                  </div>
                </template>
              </a-card-meta>
            </a-card>
          </div>
        </div>
      </template>
    </Layout>
  </div>
</template>

<script>
import Layout from "../../../components/Layout";
import MenuItems from "../../../components/MenuItems";
// import ProfileCard from "../../../components/ProfileCard";
import { mapGetters } from "vuex";
export default {
  name: "Adminreports",
  components: {
    Layout,
    MenuItems,
    // ProfileCard,
  },
  data() {
    return {
      menu: [
        {
          title: "Dashboard",
          icon: "fa fa-chart-line",
          path: "/supervisor",
        },
        {
          title: "Add Sales Agent",
          icon: "fa fa-plus",
          path: "/supervisor/agents/new",
        },
        {
          title: "Sales",
          icon: "fa fa-table",
          path: "/supervisor/sales",
        },
        {
          title: "Agents",
          icon: "fa fa-users",
          path: "/supervisor/agents",
        },
      ],
      defaultImage:
        "https://res.cloudinary.com/dvkcmubck/image/upload/v1607980060/placeholder.png",
    };
  },

  computed: {
    ...mapGetters({ agents: "agent/companyUsers" }),
  },
  beforeCreate() {
    this.$store.dispatch("agent/getCompanyAgents");
  },
};
</script>
<style scoped>
.nav-item {
  cursor: pointer;
}

.nav-item .nav-link:hover {
  color: #8bc34a;
}
</style>
